import { AuthRequirement } from '../../pages/routes'
import { RouteLink } from '../../utils/constants/router-link'
type AuthRequirementResponse = [boolean, RouteLink, never?]

export const AUTH_REQUIREMENTS: Record<
    AuthRequirement,
    () => AuthRequirementResponse
> = {
    [AuthRequirement.AUTHENTICATED]() {
        // No routes in this SPA actually require AUTHENTICATED; if any are
        // added later, redirect unauthenticated users to the coachee login
        // entry. RouteLink.ERROR is gone — its only consumer was the dead
        // /error catch-all, replaced by CoacheeWebRedirect.
        return [false, RouteLink.LOGIN_COACHEE] as AuthRequirementResponse
    },

    [AuthRequirement.UNAUTHENTICATED]() {
        // Always verified (this SPA has no auth state of its own); the route
        // is unused here but kept for type symmetry.
        return [true, RouteLink.LOGIN_COACHEE]
    },
}
